import { path } from './internal/path';
export const chromium = path('/forms/chromium');
